import React, { FC } from 'react'
import { Grid, TableCell } from '@mui/material'
import { isEqual } from 'lodash'
import { useLocation } from 'react-router-dom'
import { getSortStateVarName } from '../../utils'
import { SortButton } from './Buttons'
import { useColumnSorting, useMatchCurrentLocation, usePageFiltersSorting } from '../../hooks'
import { ContractManagementTablesEnum, TableSortPagesEnum } from '../../types'
import { OrderDirection } from '../../graphql'
import { APP_PATHS } from '../../routes/paths'

const ColumnNameWithSortComponent: FC<{
  name: string
  handleRefetch: (sortedBy: string) => void
  contractManagementType?: ContractManagementTablesEnum
  invertLabel?: boolean
  width?: string
  children: React.ReactNode
}> = ({ name, handleRefetch, contractManagementType, invertLabel, width, children, ...props }) => {
  const location = useLocation()

  const activePage = location.pathname
  const isVbanTrxPage = useMatchCurrentLocation(APP_PATHS.dashboard.vbanstransactions)
  const isAccountPage = useMatchCurrentLocation(APP_PATHS.dashboard.account)

  const pageVariable = getSortStateVarName(
    activePage,
    contractManagementType,
    isVbanTrxPage,
    isAccountPage,
  )
  const { pageFilters } = usePageFiltersSorting(pageVariable)

  const { sortData } = useColumnSorting(name, handleRefetch, contractManagementType)

  const isSortedBy = pageFilters.sortBy === name

  const isSorted = activePage.includes(TableSortPagesEnum.transactions)
    ? pageFilters.sortDirection === OrderDirection.Descending
    : pageFilters.direction === OrderDirection.Descending

  return (
    <TableCell onClick={sortData} {...props} width={width}>
      <Grid
        container
        width="100%"
        flexWrap="nowrap"
        justifyContent="space-between"
        columnGap={10}
        sx={{
          '&:hover': {
            cursor: 'pointer',
            '& svg path': {
              fill: '#EF2828',
            },
          },
        }}
      >
        <Grid>{children}</Grid>
        {isSortedBy && (
          <Grid>
            <SortButton isSorted={invertLabel ? !isSorted : isSorted} />
          </Grid>
        )}
      </Grid>
    </TableCell>
  )
}

export const ColumnNameWithSort = React.memo(ColumnNameWithSortComponent, isEqual)
